module.exports = __webpack_public_path__ + "assets/contact-icon.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/landing/contact-icon.png
// module id = 288
// module chunks = 7